import React from 'react';

const ChatMessageStatus = ({ pending = false, failed = false }) => (
  <>
    {pending && (
      <span className="cm_chat_status cm_chat_status_pending" aria-label="Sending">
        <i className="fa-solid fa-clock" />
      </span>
    )}
    {failed && (
      <span className="cm_chat_status cm_chat_status_failed" aria-label="Failed to send">
        <i className="fa-solid fa-triangle-exclamation" />
      </span>
    )}
  </>
);

export default React.memo(ChatMessageStatus);
